/* eslint-disable react/prop-types */
import classes from "./login.module.scss";
import Label from "@/components-library/widgets/label";
import Button from "@/components-library/widgets/button";
import Flex from "@/components-library/layout/flex";
import TextField from "@/components-library/widgets/text-field";
import Grid from "@/components-library/layout/grid";
import Spinner from "@/components-library/widgets/spinner";
import { BiShow, BiHide } from "react-icons/bi";
import Modal from "@/components-library/widgets/modal";
function Login({
  username,
  password,
  onUsernameChange,
  onPasswordChange,
  onLoginClick,
  onShowPasswordClick,
  showPassword,
  loggingIn,
}) {
  return (
    <Flex
      direction="column"
      justify="flex-start"
      align="center"
      className={classes.container}
    >
      <Modal isOpen={loggingIn}>
        <Spinner />
      </Modal>
      <Label
        tag="h1"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.header}
      >
        Login
      </Label>
      {/*<Status />*/}

      <Grid columns="1fr 3fr" className={classes.textFieldContainer}>
        <Label
          tag="h6"
          weight="bold"
          color="secondary"
          className={classes.title}
        >
          Username
        </Label>
        <TextField
          type="text"
          name="text"
          isEnabled={true}
          onChange={onUsernameChange}
          value={username}
          className={classes.textField}
        />
      </Grid>
      <Grid columns="1fr 3fr" className={classes.textFieldContainer}>
        <Label
          tag="h6"
          weight="bold"
          color="secondary"
          className={classes.title}
        >
          Password
        </Label>
        <Flex direction="row" justify="flex-start" align="center">
          <TextField
            type={showPassword ? "text" : "password"}
            name="text"
            isEnabled={true}
            onChange={onPasswordChange}
            value={password}
            className={classes.textField}
          />

          {!showPassword && (
            <BiHide onClick={onShowPasswordClick} className={classes.icon} />
          )}
          {showPassword && (
            <BiShow onClick={onShowPasswordClick} className={classes.icon} />
          )}
        </Flex>
      </Grid>
      <Flex direction="row" justify="flex-start" align="center">
        <Button
          onClick={onLoginClick}
          size="sm"
          color="primary"
          isEnabled={username?.length > 0 && password?.length > 0}
          className={classes.button}
        >
          Login
        </Button>
      </Flex>
    </Flex>
  );
}

export default Login;
